export default {
  name: 'Links',
  isRotated: true,
  versions: [
    'links/links_1.jpg',
    'links/links_2.jpg',
  ],
  containerStyle: {
    paddingBottom: '10%',
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  baseStyle: {
    fontFamily: 'Roboto',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textAlign: 'center',
    display: 'block',
    position: 'relative',
    lineHeight: '1',
    padding: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    fontWeight: 'bold',
    hyphens: 'auto'
  },
  customStyles: [
    {
      name: "violette box",
      style: {
        color: '#FFFFFF',
        backgroundColor: '#502583',
        textShadow:
          'none',
      }
    },
    {
      name: "weiss",
      style: {
        color: '#FFFFFF',
      }
    },
    {
      name: "orange",
      style: {
        color: '#EC7204',
      }
    },

  ],
  customContainerStyles: [
    {
      name: 'links/links_1.jpg',
      style: {
        textShadow:
          '0px 0px 30px rgba(0,0,0,0.5)',
      }
    },
    {
      name: 'links/links_2.jpg',
      style: {
        paddingBottom: '30%',
      }
    }
  ],
  linesDefault: [
    {
      text: 'Kommunismus',
      style: 0,
      fontSize: 80
    },
    {
      text: 'sagt man nicht',
      style: 1,
      fontSize: 70
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config/links.js